module.exports = {
  //yellowBaseColor: '#ffb74d',
  yellowBaseColor: '#FFD900',
  whiteBaseColor: '#000000',
  blueColor: '#0071BC',
  greenColor: '#39B54A',
  violetColor: '#93278F',
  blackColor: '#000000',
  hoverColor: 'b9d5ee',
  bottomNavBackground: '#f2f2f2',
  menuDetailsHeaderBackground: '#FFD900',
  blackLikeBackground: '#1A1311',
  secondaryColor: '#beb3b3',
  categoryDetailsTextColor: '#7f8195',
  categoryDetailsFilterTitle: '#d6d6dc',
  menuItemTitleColor: '#111111',
  bottomNavColor: '#7f8195',
};
